export const combineRefs =
  <Element,>(
    ref: React.LegacyRef<Element>,
    ...additional: (React.Ref<Element> | undefined)[]
  ) =>
  (el: Element) => {
    for (const r of additional) {
      if (!r) continue;
      if (typeof r === "function") {
        r(el);
      } else if (typeof r === "object") {
        (r as any).current = el;
      }
    }
    if (typeof ref === "function") {
      ref(el);
    } else if (ref && typeof ref === "object") {
      (ref as any).current = el;
    } else {
      return ref;
    }
  };
